module.exports = __webpack_public_path__ + "static/img/5aa8bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/1-1.png
// module id = 683
// module chunks = 2